import React, { Component } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import ExportButton from '../../Layouts/ExportButton';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';
import { DataGrid } from '@mui/x-data-grid';
import AuthApi from '../../Services/Authapi';
import ls from "local-storage";
import Chart from "chart.js/auto";
import "./Attendance.css";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Grid, Popover, Box, ListItemText } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import logo from './logo.png';
import TooltipCell from '../../TooltipCell';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import jsPDF from 'jspdf'
import { getStoredRoleNames } from '../../../utils/authSession';

import autoTable from 'jspdf-autotable';
import CommonTablePaginationActions, {
    COMMON_PAGINATION_CLASS,
    commonPaginationSelectProps,
    getCommonPaginationStyle,
} from '../../Common/commonPagination';
 

const formatDurationText = (value) => {
    if (!value || typeof value !== 'string' || value === '-' || value.toLowerCase() === 'n/a') return value;
    return value
        .replace(/\bhours?\b/gi, 'Hr')
        .replace(/\bminutes?\b/gi, 'Min')
        .replace(/\bhrs?\b/gi, 'Hr')
        .replace(/\bmins?\b/gi, 'Min');
};

const getContrastYIQ = (hexcolor) => {
    if (!hexcolor) return 'black';
    let r, g, b;
    if (hexcolor.startsWith('#')) {
        const hex = hexcolor.replace('#', '');
        if (hex.length === 3) {
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
        } else {
            r = parseInt(hex.substr(0, 2), 16);
            g = parseInt(hex.substr(2, 2), 16);
            b = parseInt(hex.substr(4, 2), 16);
        }
    } else if (hexcolor.startsWith('rgb')) {
        const rgb = hexcolor.match(/\d+/g);
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
    } else {
        return 'black';
    }
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
};

const getLocalDateParts = () => {
    const now = new Date();
    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localDate = new Date(now.getTime() - timezoneOffsetMs);

    return {
        currentDate: localDate.toISOString().split('T')[0],
        currentMonth: localDate.toISOString().slice(0, 7)
    };
};

class Attendance extends Component {
    constructor(props) {
        super(props);
        const { currentDate, currentMonth } = getLocalDateParts();
        this.state = {
            Attendance: [],
            dailyLogData: [],
            searchQueryMonthly: "",
            searchQueryDaily: "",
            suggestionsMonthly: [],
            suggestionsDaily: [],
            monthlyLoading: true,
            dailyLoading: true,
            selectedDate: currentMonth,
            selectedDatejh: currentDate,
            showMonthlyLog: false,
            pageSizeMonthly: 10,
            pageSizeDaily: 10,
            pageMonthly: 0,
            pageDaily: 0,
            modalUserStatistics: [],
            allUsers: [],
            userCache: {},
            isLoadingUsers: false,
            userPopoverAnchor: null,
            modalUserPopoverAnchor: null,
            userSearchQuery: "",
            uniqueUsers: [],
            columns: [
                {
                    field: 'serial_no',
                    headerName: 'Serial No',
                    flex: 0.5,
                    headerClassName: 'header-red',
                    renderCell: (params) => {
                        const { pageMonthly, pageSizeMonthly } = this.state;
                        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
                        return (
                            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                {pageMonthly * pageSizeMonthly + index + 1}
                            </div>
                        );
                    }
                },
                {
                    field: 'user_name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'firstname', headerName: 'Name', flex: 1, headerClassName: 'header-red',
                    align: 'left', headerAlign: 'left',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div>
                },
                {
                    field: 'date', headerName: 'Date', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'status',
                    headerName: 'Status',
                    flex: 1,
                    headerClassName: 'header-red',
                    renderCell: (params) => {
                        let statusText = params.value;
                        if (statusText === 'Comes Late') {
                            statusText = 'Late';
                        }
                        let bgColor = this.state.statusColors[statusText] || '#036dda'; // fallback color
                        return (
                            <div
                                style={{
                                    backgroundColor: bgColor,
                                    color: getContrastYIQ(bgColor),
                                    width: '140px',
                                    height: '28px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px',
                                    fontWeight: 'bold',
                                    fontSize: '12px',
                                    textAlign: 'center'
                                }}
                            >
                                {statusText}
                            </div>
                        );
                    }
                },  
                {
                    field: 'first_in_time', headerName: 'First In Time', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'last_out_time', headerName: 'Last Out Time', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'total_duration', headerName: 'Total Duration', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => (
                        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {formatDurationText(params.value)}
                        </div>
                    )
                },
                {
                    field: 'break_duration', headerName: 'Break Duration', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => (
                        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {formatDurationText(params.value)}
                        </div>
                    )
                },
                {
                    field: 'breaks', headerName: 'Breaks', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
            ],
            dailyLogColumns: [
                {
                    field: 'serial_no',
                    headerName: 'Serial No',
                    flex: 0.5,
                    headerClassName: 'header-red',
                    renderCell: (params) => {
                        const { pageDaily, pageSizeDaily } = this.state;
                        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
                        return (
                            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                {pageDaily * pageSizeDaily + index + 1}
                            </div>
                        );
                    }
                },
                {
                    field: 'user_name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'firstname', headerName: 'Name', flex: 1, headerClassName: 'header-red',
                    align: 'left', headerAlign: 'left',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div>
                },
                {
                    field: 'date', headerName: 'Date', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'time', headerName: 'Time', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'type',
                    headerName: 'Type',
                    flex: 1,
                    headerClassName: 'header-red',
                    renderCell: (params) => {

                        if (params.value === 'IN') {
                            return (
                                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>IN</span>
                                </div>
                            );
                        }
                        if (params.value === 'OUT') {
                            return (
                                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>OUT</span>
                                </div>
                            );
                        }
                        if (params.value && params.value.startsWith('IN / Comes Late')) {
                            const color = this.state.statusColors && this.state.statusColors['Late']
                                ? this.state.statusColors['Late']
                                : '#000000';
                            return (
                                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                    <span>
                                        <span style={{ color: 'green', fontWeight: 'bold' }}>IN / </span>
                                        <span style={{ color, fontWeight: 'bold' }}>Late</span>
                                    </span>
                                </div>
                            );
                        }
                        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>;
                    }
                },
                {
                    field: 'duration', headerName: 'Duration', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => (
                        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {formatDurationText(params.value)}
                        </div>
                    )
                },
            ],
            selectedUser: "",
            isUserStatsOpen: false,
            modalSelectedUser: "",
            modalSelectedMonthYear: "",
            modalAttendance: [],
        };
        this.monthlyRequestId = 0;
        this.dailyRequestId = 0;
        this.chartRef = React.createRef();
        this.handleChangeMonthly = this.handleChangeMonthly.bind(this);
        this.handleChangeDaily = this.handleChangeDaily.bind(this);
        this.handleSearchMonthly = this.handleSearchMonthly.bind(this);
        this.handleSearchDaily = this.handleSearchDaily.bind(this);
        this.clearSearchMonthly = this.clearSearchMonthly.bind(this);
        this.clearSearchDaily = this.clearSearchDaily.bind(this);
        this.handleSuggestionClickMonthly = this.handleSuggestionClickMonthly.bind(this);
        this.handleSuggestionClickDaily = this.handleSuggestionClickDaily.bind(this);
        this.handlePageSizeChangeMonthly = this.handlePageSizeChangeMonthly.bind(this);
        this.handlePageSizeChangeDaily = this.handlePageSizeChangeDaily.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
    }

    // Returns current month in YYYY-MM so month pickers cannot go to the future
    getCurrentMonth = () => getLocalDateParts().currentMonth;

    getCurrentDate = () => getLocalDateParts().currentDate;

    getRoleList = () => getStoredRoleNames();

    // Clamp any selected month to not exceed the current month
    clampToCurrentMonth = (value) => {
        const maxMonth = this.getCurrentMonth();
        if (value && value > maxMonth) {
            return maxMonth;
        }
        return value;
    };

    handlePageChangeMonthly = (event, newPage) => {
        this.setState({ pageMonthly: newPage });
    };

    handlePageChangeDaily = (event, newPage) => {
        this.setState({ pageDaily: newPage });
    };

    componentDidMount() {
        // if (!this.props.authToken) {
        //     this.props.history.push("/login");
        //     return;
        // }
        this.fetchData();
        this.fetchDailyLog();
        this.fetchUsers();
        AuthApi.getStatusColors().then((response) => {
            if (response && response.status && response.data) {
                const fetchedColors = response.data;
                const defaultColors = {
                    'Present': '#1dbb11',
                    'Absent': '#ff5c5c',
                    'Half day': '#0acdb6',
                    'Left Early': '#065112',
                    'Late': '#9d744d',
                    'Week Off': '#036dda',
                    'Holiday': '#ca04cd',
                    'Short Hours': '#ffffff'
                };

                Object.keys(defaultColors).forEach(key => {
                    if (!fetchedColors[key] || (typeof fetchedColors[key] === 'string' && (fetchedColors[key].toLowerCase() === '#ffffff' || fetchedColors[key].toLowerCase() === '#fff'))) {
                        fetchedColors[key] = defaultColors[key];
                    }
                });

                if (fetchedColors['Comes Late'] && !fetchedColors['Late']) {
                    fetchedColors['Late'] = fetchedColors['Comes Late'];
                }
                this.setState({ statusColors: fetchedColors });
            } else {
                this.setState({ statusColors: {} });
            }
        });

        // Listen for theme changes
        this.themeObserver = new MutationObserver(() => {
            if (!this.state.showMonthlyLog && this.chartInstance) {
                this.createChart();
            }
        });

        this.themeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });

        this.themeObserverBody = new MutationObserver(() => {
            if (!this.state.showMonthlyLog && this.chartInstance) {
                this.createChart();
            }
        });

        this.themeObserverBody.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    componentWillUnmount() {
        if (this.themeObserver) {
            this.themeObserver.disconnect();
        }
        if (this.themeObserverBody) {
            this.themeObserverBody.disconnect();
        }
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
    }

    // Helper: parse date_range from leave ticket ("DD-MM-YYYY To DD-MM-YYYY") and return all dates in range
    getHalfDayApprovedDates = (leaveTickets) => {
        // Returns a Set of "DD-MM-YYYY" strings that have an approved half-day leave
        // Also returns a map from date -> userId for admin matching
        const halfDayDateSet = new Set();
        if (!Array.isArray(leaveTickets)) return halfDayDateSet;
        leaveTickets.forEach(ticket => {
            if (ticket.status === 'Approved' && parseFloat(ticket.no_of_days) === 0.5) {
                // date_range is like "DD-MM-YYYY To DD-MM-YYYY"
                const parts = ticket.date_range ? ticket.date_range.split(/\s+[Tt][Oo]\s+/) : [];
                if (parts.length >= 1 && parts[0]) {
                    halfDayDateSet.add(parts[0].trim());
                }
            }
        });
        return halfDayDateSet;
    };

    formatIsoDateToDisplay = (isoDate) => {
        if (!isoDate || typeof isoDate !== "string") return "";
        const parts = isoDate.split("-");
        if (parts.length !== 3) return isoDate;
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    };

    createDailyFallbackRows = (monthlyRows, selectedDateIso) => {
        const targetDate = this.formatIsoDateToDisplay(selectedDateIso);
        if (!targetDate || !Array.isArray(monthlyRows)) {
            return [];
        }

        return monthlyRows.flatMap((row, index) => {
            if (!row || row.date !== targetDate) {
                return [];
            }

            const fallbackRows = [];
            const rowIdBase = `${row.user_id || row.userId || row.user_name || "user"}_${targetDate}_${index}`;
            const normalizedStatus = String(row.status || "").toLowerCase();
            const inType = normalizedStatus.includes("late") || normalizedStatus.includes("comes late")
                ? "IN / Comes Late"
                : "IN";

            if (row.first_in_time && row.first_in_time !== "--") {
                fallbackRows.push({
                    id: `${rowIdBase}_in`,
                    user_name: row.user_name,
                    firstname: row.firstname,
                    date: row.date,
                    time: row.first_in_time,
                    type: inType,
                    duration: "-",
                });
            }

            if (row.last_out_time && row.last_out_time !== "--") {
                fallbackRows.push({
                    id: `${rowIdBase}_out`,
                    user_name: row.user_name,
                    firstname: row.firstname,
                    date: row.date,
                    time: row.last_out_time,
                    type: "OUT",
                    duration: row.total_duration || "-",
                });
            }

            return fallbackRows;
        });
    };

    fetchData = async () => {
        const { selectedDate } = this.state;
        const [year, month] = selectedDate.split('-');
        const requestId = ++this.monthlyRequestId;
        this.setState({
            monthlyLoading: true,
            Attendance: [],
            filterEvents: [],
            pageMonthly: 0,
            suggestionsMonthly: []
        });
        try {
            const roleList = this.getRoleList();
            const isPrivileged = roleList.includes("Super Admin") || roleList.includes("Admin");
            const userId = ls.get("user").id;

            const attendancePromise = isPrivileged
                ? AuthApi.getallAttendance(month, year)
                : AuthApi.getAttendance(userId, month, year);
            const workingHoursPromise = AuthApi.getWorkingHours().catch((err) => {
                console.error("Error fetching working hours:", err);
                return null;
            });
            const leaveTicketsPromise = isPrivileged
                ? AuthApi.getTickets1().catch((err) => {
                    console.error("Error fetching leave tickets for half-day check:", err);
                    return null;
                })
                : AuthApi.leavetickets(userId, month, year).catch((err) => {
                    console.error("Error fetching leave tickets for half-day check:", err);
                    return null;
                });

            const [response, whRes, ltRes] = await Promise.all([
                attendancePromise,
                workingHoursPromise,
                leaveTicketsPromise
            ]);

            if (requestId !== this.monthlyRequestId) {
                return;
            }

            const workingHoursData = whRes && whRes.data ? whRes.data : null;

            // Fetch approved half-day leave tickets to avoid marking them as 'Left Early'
            // For employees: fetch their own tickets. For admin: fetch all tickets.
            let approvedHalfDayDatesMap = {}; // key: userId or empid, value: Set of DD-MM-YYYY dates
            let approvedHalfDayDatesAll = new Set(); // for non-admin: flat set of dates
            if (ltRes && ltRes.status === true) {
                if (!isPrivileged) {
                    approvedHalfDayDatesAll = this.getHalfDayApprovedDates(ltRes.data);
                } else {
                    ltRes.data.forEach(ticket => {
                        if (ticket.status === 'Approved' && parseFloat(ticket.no_of_days) === 0.5) {
                            const parts = ticket.date_range ? ticket.date_range.split(/\s+[Tt][Oo]\s+/) : [];
                            if (parts.length >= 1 && parts[0]) {
                                const dateStr = parts[0].trim();
                                const uid = String(ticket.user_id || ticket.userId || '');
                                if (uid) {
                                    if (!approvedHalfDayDatesMap[uid]) approvedHalfDayDatesMap[uid] = new Set();
                                    approvedHalfDayDatesMap[uid].add(dateStr);
                                }
                                approvedHalfDayDatesAll.add(dateStr);
                            }
                        }
                    });
                }
            }
            if (response && response.status === true) {
                const earlyLeaveMinHrs = workingHoursData && workingHoursData.early_leave_min_hours ? parseFloat(workingHoursData.early_leave_min_hours) : null;
                const earlyLeaveAllowedDays = workingHoursData && workingHoursData.early_leave_allowed_days ? parseInt(workingHoursData.early_leave_allowed_days, 10) : null;
                const fullDayHours = workingHoursData && workingHoursData.full_day_hours ? parseFloat(workingHoursData.full_day_hours) : 8;

                const attendanceData = [...response.data]
                    .sort((a, b) => {
                        const dateA = (a.date || "").split('-'); // DD-MM-YYYY
                        const dateB = (b.date || "").split('-');
                        if (dateA.length < 3 || dateB.length < 3) return 0;
                        // Sort by year, then month, then day (descending)
                        if (dateA[2] !== dateB[2]) return parseInt(dateB[2]) - parseInt(dateA[2]);
                        if (dateA[1] !== dateB[1]) return parseInt(dateB[1]) - parseInt(dateA[1]);
                        return parseInt(dateB[0]) - parseInt(dateA[0]);
                    })

                const earlyLeaveCountMap = {};

                const processedData = attendanceData.map((row, index) => {
                    let status = row.status;
                    const workSeconds = this.parseDurationToSeconds(row.total_duration);
                    
                    if (status && status.toLowerCase().includes('present')) {
                        if (workSeconds > 9 * 3600) { // 9 hours in seconds
                            status = "Overtime";
                        }
                    }

                    // Check if this date has an approved half-day leave ticket
                    // row.date is in "DD-MM-YYYY" format
                    const rowDateStr = row.date ? row.date.trim() : '';
                    const rowUserId = String(row.user_id || row.userId || '');
                    const isApprovedHalfDay = isPrivileged
                        ? (rowUserId && approvedHalfDayDatesMap[rowUserId] && approvedHalfDayDatesMap[rowUserId].has(rowDateStr)) || approvedHalfDayDatesAll.has(rowDateStr)
                        : approvedHalfDayDatesAll.has(rowDateStr);

                    if (isApprovedHalfDay && status && !['absent', 'leave', 'week off', 'holiday'].includes(status.toLowerCase())) {
                        // Approved half-day leave - always show as Half Day, skip Left Early logic
                        status = "Half Day";
                    } else if (status && !['absent', 'leave', 'week off', 'holiday'].includes(status.toLowerCase()) && workSeconds > 0 && earlyLeaveMinHrs != null && !isNaN(earlyLeaveMinHrs) && earlyLeaveAllowedDays != null && !isNaN(earlyLeaveAllowedDays) && fullDayHours != null && !isNaN(fullDayHours)) {
                        const minHrsSeconds = earlyLeaveMinHrs * 3600;
                        const fullHrsSeconds = fullDayHours * 3600;

                        if (workSeconds >= minHrsSeconds && workSeconds < fullHrsSeconds) {
                            const employeeId = row.user_name || row.firstname;
                            if (!earlyLeaveCountMap[employeeId]) {
                                earlyLeaveCountMap[employeeId] = 0;
                            }
                            earlyLeaveCountMap[employeeId]++;

                            if (earlyLeaveCountMap[employeeId] <= earlyLeaveAllowedDays) {
                                status = "Left Early";
                            } else {
                                status = "Half Day";
                            }
                        }
                    }

                    return {
                        ...row,
                        status: status,
                        id: row.id || `${row.user_id || row.userId || index}_${row.date || index}`
                    };
                });
                
                const finalAttendanceData = processedData; // Already sorted and indexed


                this.setState({
                    Attendance: finalAttendanceData,
                    userStatistics: response.user_statistics || [], // Store user statistics
                    monthlyLoading: false,
                }, () => {
                    this.updateUniqueUsersList();
                    // Auto-select logged-in user for monthly filter on standard users
                    if (!isPrivileged) {
                        const defaultUser = (finalAttendanceData && finalAttendanceData[0] && finalAttendanceData[0].firstname) ? finalAttendanceData[0].firstname : '';
                        if (defaultUser && this.state.selectedUser !== defaultUser) {
                            this.setState({ selectedUser: defaultUser }, this.filterBySelectedUser);
                        } else if (this.state.selectedUser) {
                            // If a user is already selected, apply the filter to new data
                            this.filterBySelectedUser();
                        } else {
                            // If no user selected, show all data
                            this.setState({ filterEvents: finalAttendanceData });
                        }
                    } else {
                        // For Admin/Super Admin, if a user is selected, apply the filter
                        if (this.state.selectedUser) {
                            this.filterBySelectedUser();
                        } else {
                            // If no user selected, show all data
                            this.setState({ filterEvents: finalAttendanceData });
                        }
                    }
                });
            } else {
                this.setState({ monthlyLoading: false, Attendance: [], filterEvents: [] });
                console.error("Failed to fetch attendance data:", response.message);
            }
        } catch (error) {
            if (requestId === this.monthlyRequestId) {
                this.setState({ monthlyLoading: false, Attendance: [], filterEvents: [] });
            }
            console.error("Error fetching attendance data:", error);
        }
    };


    fetchDailyLog = async (id) => {
        const { selectedDatejh } = this.state;
        const [year, month, day] = selectedDatejh.split('-');
        const requestId = ++this.dailyRequestId;
        this.setState({
            dailyLoading: true,
            dailyLogData: [],
            filterEventsDaily: [],
            pageDaily: 0,
            suggestionsDaily: []
        });
        try {
            const roleList = this.getRoleList();
            const isPrivileged = roleList.includes("Super Admin") || roleList.includes("Admin");
            let response;

            if (isPrivileged) {
                response = await AuthApi.getalldatadailylog(day, month, year);
            } else {
                response = await AuthApi.getdailylog(ls.get("user").id, day, month, year);
            }

            if (requestId !== this.dailyRequestId) {
                return;
            }

            if (response && response.status === true && Array.isArray(response.data) && response.data.length > 0) {
                const dailyLogData = response.data.map((row, index) => ({
                    ...row,
                    id: row.id || `${row.user_id || row.userId || index}_${row.date || index}_${index}`
                }));
                this.setState({
                    dailyLogData: dailyLogData,
                    filterEventsDaily: dailyLogData,
                    dailyLoading: false,
                }, this.createChart);
            } else {
                let fallbackRows = this.createDailyFallbackRows(this.state.Attendance, selectedDatejh);

                if (fallbackRows.length === 0) {
                    const monthlyFallbackResponse = isPrivileged
                        ? await AuthApi.getallAttendance(month, year)
                        : await AuthApi.getAttendance(ls.get("user").id, month, year);

                    if (monthlyFallbackResponse && monthlyFallbackResponse.status === true) {
                        fallbackRows = this.createDailyFallbackRows(monthlyFallbackResponse.data || [], selectedDatejh);
                    }
                }

                this.setState({
                    dailyLoading: false,
                    dailyLogData: fallbackRows,
                    filterEventsDaily: fallbackRows
                }, this.createChart);

                if (fallbackRows.length === 0) {
                    console.error("Failed to fetch daily log data:", response && response.message);
                }
            }
        } catch (error) {
            if (requestId === this.dailyRequestId) {
                this.setState({ dailyLoading: false, dailyLogData: [], filterEventsDaily: [] });
            }
            console.error("Error fetching daily log data:", error);
        }
    };

    handleOpenUserPopover = (event) => {
        this.setState({ userPopoverAnchor: event.currentTarget, userSearchQuery: "" });
    };

    handleCloseUserPopover = () => {
        this.setState({ userPopoverAnchor: null, userSearchQuery: "" });
    };

    handleOpenModalUserPopover = (event) => {
        this.setState({ modalUserPopoverAnchor: event.currentTarget, userSearchQuery: "" });
    };

    handleCloseModalUserPopover = () => {
        this.setState({ modalUserPopoverAnchor: null, userSearchQuery: "" });
    };

    handleSelectUser = (userName) => {
        this.handleUserChange({ target: { value: userName } });
        this.handleCloseUserPopover();
    };

    handleSelectModalUser = (userName) => {
        this.handleModalUserChange({ target: { value: userName } });
        this.handleCloseModalUserPopover();
    };

    fetchUsers = async () => {
        try {
            // Load from cache for immediate display
            try {
                const cachedUsers = ls.get('cached_all_users');
                if (cachedUsers && Array.isArray(cachedUsers) && this.state.allUsers.length === 0) {
                    const cacheMap = {};
                    cachedUsers.forEach(u => { if (u.id) cacheMap[String(u.id)] = u; });
                    this.setState({ allUsers: cachedUsers, userCache: { ...this.state.userCache, ...cacheMap } });
                }
            } catch (e) {
                console.warn("Failed to load users from cache", e);
            }

            this.setState({ isLoadingUsers: true });
            const response = await AuthApi.getData();

            let list = [];
            if (response && response.status === true && Array.isArray(response.data)) {
                list = response.data;
            } else if (Array.isArray(response)) {
                list = response;
            } else if (response && Array.isArray(response.data)) {
                list = response.data;
            }

            if (list.length > 0) {
                const cacheMap = {};
                list.forEach(u => { if (u.id) cacheMap[String(u.id)] = u; });
                this.setState({ allUsers: list, userCache: { ...this.state.userCache, ...cacheMap } }, () => {
                    this.updateUniqueUsersList();
                });
                ls.set('cached_all_users', list);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            this.setState({ isLoadingUsers: false });
        }
    };

    updateUniqueUsersList = () => {
        const { Attendance, userCache } = this.state;
        if (!Attendance || Attendance.length === 0) {
            this.setState({ uniqueUsers: [] });
            return;
        }

        const userMap = new Map();
        Attendance.forEach(item => {
            if (item.firstname && !userMap.has(item.firstname)) {
                const name = item.firstname;
                const userId = String(item.user_id || item.userId || '');
                const userInfo = userCache[userId];
                userMap.set(name, {
                    name: name,
                    id: userId,
                    photo: userInfo ? userInfo.photo : null,
                    initials: name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)
                });
            }
        });
        const uniqueUsers = Array.from(userMap.values()).sort((a, b) => a.name.localeCompare(b.name));
        this.setState({ uniqueUsers });
    };



    handleShowDailyLog = () => {
        this.setState({ showMonthlyLog: false }, () => {
            this.fetchDailyLog(ls.get("user").id);
        });
    };

    handleDateChange = (event) => {
        const selectedDate = this.clampToCurrentMonth(event.target.value);
        this.setState({
            selectedDate,
            monthlyLoading: true,
            Attendance: [],
            filterEvents: [],
            pageMonthly: 0,
            suggestionsMonthly: []
        }, () => {
            this.fetchData();
        });
    };

    handleModalMonthChange = (event) => {
        const modalSelectedMonthYear = this.clampToCurrentMonth(event.target.value);
        this.setState({ modalSelectedMonthYear }, this.fetchModalAttendance);
    };

    handledayChange = (event) => {
        const selectedDatejh = event.target.value > this.getCurrentDate()
            ? this.getCurrentDate()
            : event.target.value;
        this.setState({
            selectedDatejh,
            dailyLoading: true,
            dailyLogData: [],
            filterEventsDaily: [],
            pageDaily: 0,
            suggestionsDaily: []
        }, this.fetchDailyLog);
    };

    handleShowMonthlyLog = () => {
        if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null;
        }
        this.setState({ showMonthlyLog: true });
    };







    createChart = () => {
        const { dailyLogData } = this.state;
        const canvas = this.chartRef ? this.chartRef.current : null;
        if (!canvas) {
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }
            return;
        }
        if (!Array.isArray(dailyLogData) || dailyLogData.length === 0) {
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }
            return;
        }
        const userLogs = {};
        const inToOutData = [];
        const breakData = [];

        dailyLogData.forEach(log => {
            const timeParts = log.time.split(':');
            const hours = parseInt(timeParts[0], 10);
            const minutes = parseInt(timeParts[1], 10);
            const seconds = parseInt(timeParts[2].split(' ')[0], 10);
            const period = timeParts[2].split(' ')[1];
            let timeIn24HourFormat = hours;
            if (period === 'PM' && hours !== 12) {
                timeIn24HourFormat += 12;
            } else if (period === 'AM' && hours === 12) {
                timeIn24HourFormat = 0;
            }
            const timeInHours = timeIn24HourFormat + minutes / 60 + seconds / 3600;
            if (!userLogs[log.firstname]) {
                userLogs[log.firstname] = [];
            }
            userLogs[log.firstname].push({
                time: timeInHours,
                type: log.type
            });
        });

        Object.keys(userLogs).forEach(userName => {
            const logs = userLogs[userName];
            for (let i = 0; i < logs.length - 1; i++) {
                const currentLog = logs[i];
                const nextLog = logs[i + 1];
                if (currentLog.type === 'IN' && nextLog.type === 'OUT') {
                    inToOutData.push({
                        x: [currentLog.time, nextLog.time],
                        y: userName
                    });
                } else if (currentLog.type === 'OUT' && nextLog.type === 'IN') {
                    breakData.push({
                        x: [currentLog.time, nextLog.time],
                        y: userName
                    });
                }
            }
        });

        if (this.chartInstance) {
            this.chartInstance.destroy();
        }

        // Detect dark mode
        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark' ||
            document.body.classList.contains('dark-theme');
        const textColor = isDarkMode ? '#ffffff' : '#000000';
        const gridColor = isDarkMode ? '#4a4a4a' : '#e0e0e0';

        const ctx = canvas.getContext("2d");
        this.chartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'IN & OUT',
                        data: inToOutData,
                        backgroundColor: 'rgba(54, 162, 235, 0.6)',
                        borderColor: 'rgba(54, 162, 235, 1)',
                        borderWidth: 2,
                        barThickness: 10,
                        borderSkipped: false
                    },
                    {
                        label: 'BREAKS',
                        data: breakData,
                        backgroundColor: 'rgba(255, 99, 132, 0.6)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 2,
                        barThickness: 10,
                        borderSkipped: false
                    }
                ]
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        type: 'linear',
                        position: 'bottom',
                        min: 9,
                        max: 21,
                        ticks: {
                            stepSize: 1,
                            color: textColor,
                            callback: function (value) {
                                const hour = Math.floor(value);
                                const period = hour >= 12 ? 'PM' : 'AM';
                                const hour12 = hour % 12 || 12;
                                return `${hour12}:00 ${period}`;
                            }
                        },
                        grid: {
                            color: gridColor
                        }
                    },
                    y: {
                        type: 'category',
                        labels: Object.keys(userLogs),
                        ticks: {
                            color: textColor
                        },
                        grid: {
                            color: gridColor
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            color: textColor,
                            font: {
                                weight: 'bold',
                                size: 12
                            },
                            generateLabels: function (chart) {
                                const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark' ||
                                    document.body.classList.contains('dark-theme');
                                const labelColor = isDarkMode ? '#ffffff' : '#000000';
                                return [
                                    {
                                        text: 'IN & OUT',
                                        fillStyle: 'rgba(54, 162, 235, 0.6)',
                                        strokeStyle: 'rgba(54, 162, 235, 1)',
                                        lineWidth: 1,
                                        fontColor: labelColor
                                    },
                                    {
                                        text: 'BREAKS',
                                        fillStyle: 'rgba(255, 99, 132, 0.6)',
                                        strokeStyle: 'rgba(255, 99, 132, 1)',
                                        lineWidth: 1,
                                        fontColor: labelColor
                                    }
                                ];
                            }
                        }
                    },
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.raw.x;
                                const startTime = value[0];
                                const endTime = value[1];

                                const formatTime = (time) => {
                                    const hour = Math.floor(time);
                                    const minute = Math.floor((time % 1) * 60);
                                    const period = hour >= 12 ? 'PM' : 'AM';
                                    const hour12 = hour % 12 || 12;
                                    return `${hour12}:${minute < 10 ? '0' : ''}${minute} ${period}`;
                                };

                                const icon = label === 'BREAKS' ? '🟥' : '🟦';
                                return `${icon} ${label}: ${formatTime(startTime)} - ${formatTime(endTime)}`;
                            },
                            afterBody: function (context) {
                                const ctx = context[0];
                                const value = ctx.raw.x;
                                const startTime = value[0];
                                const endTime = value[1];
                                const durationInHours = endTime - startTime;
                                const totalMinutes = Math.round(durationInHours * 60);
                                const h = Math.floor(totalMinutes / 60);
                                const m = totalMinutes % 60;
                                const durationStr = h > 0 ? `${h} Hr ${m} Min` : `${m} Min`;
                                return `🕒 Duration: ${durationStr}`;
                            }
                        }
                    }
                }
            }
        });
    };

    // Helpers for user stats modal
    openUserStatsModal = () => {
        const { selectedUser, selectedDate, Attendance } = this.state;
        const roles = ls.get("roles");
        const isSuperAdmin = roles && roles.includes("Super Admin");
        let modalUser = selectedUser || "";
        if (!isSuperAdmin) {
            // For non-super admins, Attendance contains only their rows. Use the exact name string from data
            const row = Array.isArray(Attendance) && Attendance.length > 0 ? Attendance[0] : null;
            modalUser = (row && row.firstname) ? row.firstname : modalUser;
        }
        this.setState({ isUserStatsOpen: true, modalSelectedUser: modalUser, modalSelectedMonthYear: selectedDate, modalAttendance: [] }, this.fetchModalAttendance);
    };

    closeUserStatsModal = () => {
        this.setState({ isUserStatsOpen: false });
    };

    fetchModalAttendance = async () => {
        const { modalSelectedMonthYear } = this.state;
        if (!modalSelectedMonthYear) return;
        const [year, month] = modalSelectedMonthYear.split('-');
        try {
            const roles = ls.get("roles");
            const isPrivileged = roles && (roles.includes("Super Admin") || roles.includes("Admin"));
            let response;
            
            let workingHoursData = null;
            try {
                const whRes = await AuthApi.getWorkingHours();
                if (whRes && whRes.data) {
                    workingHoursData = whRes.data;
                }
            } catch (err) {
                console.error("Error fetching working hours:", err);
            }

            // Fetch approved half-day leave tickets (same logic as fetchData)
            let approvedHalfDayDatesMap = {};
            let approvedHalfDayDatesAll = new Set();
            try {
                if (!isPrivileged) {
                    const userId = ls.get("user").id;
                    const ltRes = await AuthApi.leavetickets(userId, month, year);
                    if (ltRes && ltRes.status === true) {
                        approvedHalfDayDatesAll = this.getHalfDayApprovedDates(ltRes.data);
                    }
                } else {
                    const ltRes = await AuthApi.getTickets1();
                    if (ltRes && ltRes.status === true) {
                        ltRes.data.forEach(ticket => {
                            if (ticket.status === 'Approved' && parseFloat(ticket.no_of_days) === 0.5) {
                                const parts = ticket.date_range ? ticket.date_range.split(/\s+[Tt][Oo]\s+/) : [];
                                if (parts.length >= 1 && parts[0]) {
                                    const dateStr = parts[0].trim();
                                    const uid = String(ticket.user_id || ticket.userId || '');
                                    if (uid) {
                                        if (!approvedHalfDayDatesMap[uid]) approvedHalfDayDatesMap[uid] = new Set();
                                        approvedHalfDayDatesMap[uid].add(dateStr);
                                    }
                                    approvedHalfDayDatesAll.add(dateStr);
                                }
                            }
                        });
                    }
                }
            } catch (err) {
                console.error("Error fetching leave tickets for half-day check:", err);
            }

            if (isPrivileged) {
                response = await AuthApi.getallAttendance(month, year);
            } else {
                response = await AuthApi.getAttendance(ls.get("user").id, month, year);
            }
            if (response && response.status === true) {
                const earlyLeaveMinHrs = workingHoursData && workingHoursData.early_leave_min_hours ? parseFloat(workingHoursData.early_leave_min_hours) : null;
                const earlyLeaveAllowedDays = workingHoursData && workingHoursData.early_leave_allowed_days ? parseInt(workingHoursData.early_leave_allowed_days, 10) : null;
                const fullDayHours = workingHoursData && workingHoursData.full_day_hours ? parseFloat(workingHoursData.full_day_hours) : 8;

                const sortedData = [...response.data].sort((a, b) => {
                    const dateA = a.date ? a.date.split('-').reverse().join('-') : '';
                    const dateB = b.date ? b.date.split('-').reverse().join('-') : '';
                    return new Date(dateA) - new Date(dateB);
                });

                const earlyLeaveCountMap = {};

                let attendanceData = sortedData.map((row, index) => {
                    let status = row.status;
                    const workSeconds = this.parseDurationToSeconds(row.total_duration);
                    
                    if (status && status.toLowerCase().includes('present')) {
                        if (workSeconds > 9 * 3600) { // 9 hours in seconds
                            status = "Overtime";
                        }
                    }

                    // Check approved half-day leave ticket
                    const rowDateStr = row.date ? row.date.trim() : '';
                    const rowUserId = String(row.user_id || row.userId || '');
                    const isApprovedHalfDay = isPrivileged
                        ? (rowUserId && approvedHalfDayDatesMap[rowUserId] && approvedHalfDayDatesMap[rowUserId].has(rowDateStr)) || approvedHalfDayDatesAll.has(rowDateStr)
                        : approvedHalfDayDatesAll.has(rowDateStr);

                    if (isApprovedHalfDay && status && !['absent', 'leave', 'week off', 'holiday'].includes(status.toLowerCase())) {
                        status = "Half Day";
                    } else if (status && !['absent', 'leave', 'week off', 'holiday'].includes(status.toLowerCase()) && workSeconds > 0 && earlyLeaveMinHrs != null && !isNaN(earlyLeaveMinHrs) && earlyLeaveAllowedDays != null && !isNaN(earlyLeaveAllowedDays) && fullDayHours != null && !isNaN(fullDayHours)) {
                        const minHrsSeconds = earlyLeaveMinHrs * 3600;
                        const fullHrsSeconds = fullDayHours * 3600;

                        if (workSeconds >= minHrsSeconds && workSeconds < fullHrsSeconds) {
                            const employeeId = row.user_name || row.firstname;
                            if (!earlyLeaveCountMap[employeeId]) {
                                earlyLeaveCountMap[employeeId] = 0;
                            }
                            earlyLeaveCountMap[employeeId]++;

                            if (earlyLeaveCountMap[employeeId] <= earlyLeaveAllowedDays) {
                                status = "Left Early";
                            } else {
                                status = "Half Day";
                            }
                        }
                    }

                    return {
                        id: index + 1,
                        ...row,
                        status: status
                    };
                });
                
                attendanceData.sort((a, b) => {
                    const dateA = a.date ? a.date.split('-').reverse().join('-') : ''; 
                    const dateB = b.date ? b.date.split('-').reverse().join('-') : '';
                    return new Date(dateB) - new Date(dateA);
                });

                attendanceData = attendanceData.map((row, index) => ({
                    ...row,
                    id: index + 1
                }));

                this.setState({
                    modalAttendance: attendanceData,
                    modalUserStatistics: response.user_statistics || []
                });
            } else {
                this.setState({ modalAttendance: [], modalUserStatistics: [] });
            }
        } catch (e) {
            this.setState({ modalAttendance: [], modalUserStatistics: [] });
        }
    };

    handleModalUserChange = (event) => {
        this.setState({ modalSelectedUser: event.target.value });
    };

    parseDurationToSeconds = (value) => {
        if (!value || typeof value !== 'string') return 0;
        const sanitized = value.trim();
        if (!sanitized || sanitized.toLowerCase() === 'n/a' || sanitized === '-') return 0;
        const lower = sanitized.toLowerCase();
        // Textual forms like "10 hours 30 minutes", "8 hr", "45 mins", "10h 30m", etc.
        const hourMatch = lower.match(/(\d+(?:\.\d+)?)\s*(?:hours?|hrs?|hr|h)\b/);
        const minuteMatch = lower.match(/(\d+(?:\.\d+)?)\s*(?:minutes?|mins?|min|m)\b/);
        const secondMatch = lower.match(/(\d+(?:\.\d+)?)\s*(?:seconds?|secs?|sec|s)\b/);
        if (hourMatch || minuteMatch || secondMatch) {
            const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
            const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;
            const seconds = secondMatch ? parseFloat(secondMatch[1]) : 0;
            return Math.round(hours * 3600 + minutes * 60 + seconds);
        }
        // Colon-based format HH:MM:SS or MM:SS
        if (sanitized.includes(':')) {
            const parts = sanitized.split(':').map(p => parseInt(p, 10));
            if (parts.some(isNaN)) return 0;
            if (parts.length === 3) {
                const [h, m, s] = parts;
                return (h * 3600) + (m * 60) + s;
            }
            if (parts.length === 2) {
                const [m, s] = parts;
                return (m * 60) + s;
            }
        }
        // Fallback: treat single number as minutes
        const numeric = parseFloat(sanitized);
        if (!isNaN(numeric)) {
            return Math.round(numeric * 60);
        }
        return 0;
    };

    formatSecondsToHMS = (totalSeconds) => {
        const seconds = Math.max(0, Math.floor(totalSeconds));
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        const hh = String(h).padStart(2, '0');
        const mm = String(m).padStart(2, '0');
        const ss = String(s).padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
    };

    formatSecondsToHoursText = (totalSeconds) => {
        const seconds = Math.max(0, Math.floor(totalSeconds));
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        if (hours > 0 && minutes === 0) {
            return `${hours} Hr`;
        }
        if (hours > 0) {
            return `${hours} Hr ${minutes} Min`;
        }
        return `${minutes} Min`;
    };

    computeUserMonthlyAndWeeklyTotals = () => {
        const { modalAttendance, Attendance, modalSelectedUser, selectedDate, modalSelectedMonthYear } = this.state;
        if (!modalSelectedUser) {
            return { monthly: { work: 0, break: 0 }, weekly: [], weeklyBreak: [], weeklyDays: [], weeklyWeekdayWork: [], sumWeeklyWork: 0, sumWeeklyBreak: 0, sumWeekdayWork: 0, weeklyDateRanges: [] };
        }
        const [selectedYear, selectedMonth] = (modalSelectedMonthYear || selectedDate).split('-');
        let monthlyWork = 0;
        let monthlyBreak = 0;
        let monthlyPresentDays = 0;
        const weeklyTotals = [];
        const weeklyBreakTotals = [];
        const weeklyDays = [];
        const weeklyWeekdayWork = [];
        const weeklyDateRanges = [];

        const firstDayOfMonth = new Date(selectedYear, selectedMonth - 1, 1);
        const lastDayOfMonth = new Date(selectedYear, selectedMonth, 0);
        const daysInMonth = lastDayOfMonth.getDate();
        const weeklyRanges = [];
        const firstDow = firstDayOfMonth.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
        const daysToFirstMonday = firstDow === 0 ? 1 : (8 - firstDow) % 7;
        const firstMonday = 1 + daysToFirstMonday;
        if (firstDow >= 1 && firstDow <= 5) {
            const firstWeekEnd = Math.min(1 + (5 - firstDow), daysInMonth);
            weeklyRanges.push({ start: 1, end: firstWeekEnd });
        }
        let currentMonday = (firstDow === 1) ? firstMonday + 7 : firstMonday;
        while (currentMonday <= daysInMonth) {
            const start = currentMonday;
            const end = Math.min(currentMonday + 4, daysInMonth);
            weeklyRanges.push({ start, end });
            currentMonday += 7;
        }
        if (weeklyRanges.length > 5) {
            weeklyRanges.length = 5;
        }
        for (let i = 0; i < weeklyRanges.length; i++) {
            weeklyTotals.push(0);
            weeklyBreakTotals.push(0);
            weeklyDays.push(0);
            weeklyWeekdayWork.push(0);
        }
        for (let i = 0; i < weeklyRanges.length; i++) {
            const { start, end } = weeklyRanges[i];
            const startDate = new Date(selectedYear, selectedMonth - 1, start);
            const endDate = new Date(selectedYear, selectedMonth - 1, end);
            const startFormatted = startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            const endFormatted = endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            weeklyDateRanges.push(start === end ? startFormatted : `${startFormatted} - ${endFormatted}`);
        }

        const source = modalSelectedMonthYear ? modalAttendance : Attendance;

        source.forEach(row => {
            if (!row || row.firstname !== modalSelectedUser) return;
            const dateStr = row.date || '';
            const parts = dateStr.split('-');
            if (parts.length !== 3) return;
            const day = parseInt(parts[0], 10);
            const month = parts[1];
            const year = parts[2];
            if (year !== selectedYear || month !== selectedMonth) return;

            const workSec = this.parseDurationToSeconds(row.total_duration);
            const breakSec = this.parseDurationToSeconds(row.break_duration);
            monthlyWork += workSec;
            monthlyBreak += breakSec;

            // Calculate which week this day belongs to using the precomputed ranges
            const currentDate = new Date(`${year}-${month}-${String(day).padStart(2, '0')}`);
            const dow = currentDate.getDay(); // 0=Sun, 1=Mon, ... 6=Sat
            let weekIndex = -1;
            if (dow >= 1 && dow <= 5) {
                weekIndex = weeklyRanges.findIndex(r => day >= r.start && day <= r.end);
            }

            if (weekIndex >= 0 && weekIndex < weeklyRanges.length) {
                weeklyTotals[weekIndex] += workSec;
                weeklyBreakTotals[weekIndex] += breakSec;

                // Count weekdays (Mon-Fri) and their work totals
                if (dow >= 1 && dow <= 5) {
                    if (workSec > 0) {
                        weeklyDays[weekIndex] += 1;
                    }
                    weeklyWeekdayWork[weekIndex] += workSec;
                }
            }

            // Monthly present day counting (status has 'present' or any positive workSec)
            const statusLower = (row.status || '').toLowerCase();
            const isPresent = statusLower.includes('present') || workSec > 0;
            if (isPresent) {
                monthlyPresentDays += 1;
            }
        });

        const sumWeeklyWork = weeklyTotals.reduce((a, b) => a + b, 0);
        const sumWeeklyBreak = weeklyBreakTotals.reduce((a, b) => a + b, 0);
        const sumWeekdayWork = weeklyWeekdayWork.reduce((a, b) => a + b, 0);
        return {
            monthly: { work: monthlyWork, break: monthlyBreak, presentDays: monthlyPresentDays },
            weekly: weeklyTotals,
            weeklyBreak: weeklyBreakTotals,
            weeklyDays,
            weeklyWeekdayWork,
            sumWeeklyWork,
            sumWeeklyBreak,
            sumWeekdayWork,
            weeklyDateRanges
        };
    };

    getModalUserInfo = () => {
        const { modalSelectedUser, modalSelectedMonthYear, modalAttendance, Attendance } = this.state;
        if (!modalSelectedUser) return { name: '', employeeId: '' };
        const source = modalSelectedMonthYear ? modalAttendance : Attendance;
        let row = Array.isArray(source) ? source.find(r => r && r.firstname === modalSelectedUser) : null;
        if (!row && Array.isArray(Attendance)) {
            row = Attendance.find(r => r && r.firstname === modalSelectedUser);
        }
        const employeeId = row && row.user_name ? row.user_name : '';
        return { name: modalSelectedUser, employeeId };
    };

    isNonWorkingStatus = (status) => {
        const normalizedStatus = String(status || '').trim().toLowerCase();
        return normalizedStatus === 'week off' || normalizedStatus === 'weekoff' || normalizedStatus === 'holiday';
    };

    getDefaultUserStatistics = () => ({
        comes_late_count: 0,
        absent_count: 0,
        leave_count: 0,
        leave_days_count: 0,
        half_day_count: 0,
        present_count: 0,
        week_off_count: 0,
        holiday_count: 0,
        left_early_count: 0
    });

    getEffectiveUserStatistics = (userStats = {}, attendanceRows = [], userName = '') => {
        const baseStats = {
            ...this.getDefaultUserStatistics(),
            ...(userStats || {})
        };

        if (!Array.isArray(attendanceRows) || attendanceRows.length === 0) {
            return baseStats;
        }

        const computedStats = this.getDefaultUserStatistics();

        attendanceRows.forEach((row) => {
            if (!row) return;
            if (userName && row.firstname !== userName) return;

            const normalizedStatus = String(row.status || '').trim().toLowerCase();

            switch (normalizedStatus) {
                case 'comes late':
                case 'late':
                    computedStats.comes_late_count += 1;
                    break;
                case 'absent':
                    computedStats.absent_count += 1;
                    break;
                case 'leave':
                    computedStats.leave_count += 1;
                    break;
                case 'half day':
                    computedStats.half_day_count += 1;
                    break;
                case 'present':
                    computedStats.present_count += 1;
                    break;
                case 'week off':
                case 'weekoff':
                    computedStats.week_off_count += 1;
                    break;
                case 'holiday':
                    computedStats.holiday_count += 1;
                    break;
                case 'left early':
                    computedStats.left_early_count += 1;
                    break;
                default:
                    break;
            }
        });

        return {
            ...baseStats,
            ...computedStats
        };
    };

    getWorkingDayCountForRow = (row = {}) => {
        const explicitValue = Number(row.working_day_count);
        if (!Number.isNaN(explicitValue) && explicitValue >= 0) {
            return explicitValue;
        }

        const normalizedStatus = String(row.status || row.attendance || '').trim().toLowerCase();

        if (['present', 'comes late', 'late', 'left early'].includes(normalizedStatus)) {
            return 1;
        }

        if (normalizedStatus === 'half day') {
            return 0.5;
        }

        return 0;
    };

    getTotalWorkingDays = (userStats = {}, attendanceRows = [], userName = '') => {
        if (Array.isArray(attendanceRows) && attendanceRows.length > 0) {
            const workingDaysByDate = new Map();

            attendanceRows.forEach((row) => {
                if (!row || !row.date) return;
                if (userName && row.firstname !== userName) return;

                const dateKey = String(row.date).trim();
                const workingDayCount = this.getWorkingDayCountForRow(row);
                const existingCount = workingDaysByDate.get(dateKey) || 0;

                workingDaysByDate.set(dateKey, Math.max(existingCount, workingDayCount));
            });

            return Array.from(workingDaysByDate.values()).reduce((sum, count) => sum + count, 0);
        }

        const presentCount = Number(userStats?.present_count) || 0;
        const lateCount = Number(userStats?.comes_late_count) || 0;
        const leftEarlyCount = Number(userStats?.left_early_count) || 0;
        const halfDayCount = Number(userStats?.half_day_count) || 0;
        const computedValue = presentCount + lateCount + leftEarlyCount + (halfDayCount * 0.5);

        if (computedValue > 0) {
            return computedValue;
        }

        const backendValue = Number(userStats?.total_working_days);
        if (!Number.isNaN(backendValue) && backendValue >= 0) {
            return backendValue;
        }

        return 0;
    };

    getTotalMonthWorkingDays = (selectedMonthYear, userStats = {}, attendanceRows = [], userName = '') => {
        const backendValue = userStats && userStats.total_month_working_days;
        if (backendValue !== undefined && backendValue !== null && backendValue !== '') {
            const parsedValue = Number(backendValue);
            if (!Number.isNaN(parsedValue)) {
                return parsedValue;
            }
        }

        if (!selectedMonthYear || !selectedMonthYear.includes('-')) {
            return 0;
        }

        const [year, month] = selectedMonthYear.split('-').map(Number);
        if (!year || !month) {
            return 0;
        }

        const lastDayOfMonth = new Date(year, month, 0).getDate();
        let weekdayCount = 0;
        for (let day = 1; day <= lastDayOfMonth; day++) {
            const jsDate = new Date(year, month - 1, day);
            const dayOfWeek = jsDate.getDay();
            if (dayOfWeek >= 1 && dayOfWeek <= 5) {
                weekdayCount++;
            }
        }

        if (!Array.isArray(attendanceRows) || attendanceRows.length === 0) {
            return weekdayCount;
        }

        const holidayDates = new Set();
        attendanceRows.forEach((row) => {
            if (!row || !row.date) return;
            if (userName && row.firstname !== userName) return;
            const normalizedStatus = String(row.status || '').trim().toLowerCase();
            if (normalizedStatus !== 'holiday') return;

            const parts = String(row.date).trim().split('-');
            if (parts.length !== 3) return;
            const [day, rowMonth, rowYear] = parts.map(Number);
            if (rowYear !== year || rowMonth !== month) return;

            const jsDate = new Date(rowYear, rowMonth - 1, day);
            const dayOfWeek = jsDate.getDay();
            if (dayOfWeek >= 1 && dayOfWeek <= 5) {
                holidayDates.add(String(row.date).trim());
            }
        });

        return Math.max(weekdayCount - holidayDates.size, 0);
    };

    downloadModalPdf = async () => {
        const { modalSelectedMonthYear, selectedDate, modalUserStatistics, modalAttendance } = this.state;
        const stats = this.computeUserMonthlyAndWeeklyTotals();
        const userInfo = this.getModalUserInfo();
        const selMY = modalSelectedMonthYear || selectedDate;
        const [y, m] = selMY.split('-');
        const monthName = new Date(`${y}-${m}-01T00:00:00`).toLocaleString('en-US', { month: 'long', year: 'numeric' });

        const doc = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });

        // Page geometry
        const pageWidth = (doc.internal.pageSize.getWidth && doc.internal.pageSize.getWidth()) || doc.internal.pageSize.width;
        const margin = 40;

        // Add company logo at top-left
        try {
            const base64Image = await this.getBase64ImageFromUrl(logo);
            if (base64Image) {
                const imgWidth = 70;
                const imgHeight = 50;
                const x = margin;
                const yImg = 20;
                doc.addImage(base64Image, 'PNG', x, yImg, imgWidth, imgHeight);
            }
        } catch (e) {
            console.warn('Logo image could not be loaded for PDF export:', e);
        }

        // Right-aligned title and month strings
        doc.setFontSize(16);
        doc.text('User Attendance Summary', pageWidth - margin, 40, { align: 'right' });
        doc.setFontSize(11);
        doc.setTextColor(100);
        doc.text(`${monthName}`, pageWidth - margin, 58, { align: 'right' });

        // User details table
        const userDetailsBody = [
            ['User', userInfo.name || '-'],
            ['Employee ID', userInfo.employeeId || '-'],
        ];
        autoTable(doc, {
            startY: 72,
            head: [['User Details', '']],
            body: userDetailsBody,
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'left' },
            columnStyles: { 1: { halign: 'right' } },
            theme: 'grid',
        });

        // Find user statistics for the selected user
        const userStats = this.getEffectiveUserStatistics(
            modalUserStatistics.find(stat => stat.firstname === userInfo.name) || this.getDefaultUserStatistics(),
            modalAttendance,
            userInfo.name
        );
        const totalWorkingDays = this.getTotalWorkingDays(userStats, modalAttendance, userInfo.name);
        const totalMonthWorkingDays = this.getTotalMonthWorkingDays(selMY, userStats, modalAttendance, userInfo.name);

        // User statistics table (horizontal)
        const userStatsHeaders = ['Late', 'Absent/Leave', 'Half Day', 'Present', 'Week Off', 'Holiday', 'Left Early', 'Leave Days', 'Total Working Day', 'Total Month Working Days'];
        const absentLeaveCount = `${userStats.absent_count || 0}/${userStats.leave_count || 0}`;
        const userStatsCounts = [
            String(userStats.comes_late_count || 0),
            absentLeaveCount,
            String(userStats.half_day_count || 0),
            String(userStats.present_count || 0),
            String(userStats.week_off_count || 0),
            String(userStats.holiday_count || 0),
            String(userStats.left_early_count || 0),
            String(userStats.leave_days_count || 0),
            String(totalWorkingDays || 0),
            String(totalMonthWorkingDays || 0)
        ];
        autoTable(doc, {
            startY: (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 12 : 120,
            head: [userStatsHeaders],
            body: [userStatsCounts],
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'center' },
            columnStyles: Object.fromEntries(userStatsHeaders.map((_, index) => [index, { halign: 'center' }])),
            theme: 'grid',
        });

        // Monthly totals table
        const monthlyBody = [
            ['Work', this.formatSecondsToHoursText(stats.monthly.work)],
            ['Present Days', String(stats.monthly.presentDays)],
        ];

        // Add Leave Days if available
        if (userStats.leave_days_count && userStats.leave_days_count > 0) {
            monthlyBody.push(['Leave Days', String(userStats.leave_days_count)]);
        }
        monthlyBody.push(['Total Working Day', String(totalWorkingDays || 0)]);
        monthlyBody.push(['Total Month Working Days', String(totalMonthWorkingDays || 0)]);
        autoTable(doc, {
            startY: (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 12 : 200,
            head: [['Monthly Totals', '']],
            body: monthlyBody,
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'left' },
            columnStyles: { 1: { halign: 'right' } },
            theme: 'grid',
        });

        // Weekly totals table
        const weeklyHead = ['Week', 'Present Days', 'Total Hrs.'];
        const statsComputed = stats; // already computed above
        const weeklyBody = statsComputed.weeklyDateRanges.map((dateRange, i) => [
            `Week ${i + 1} (${dateRange || ''})`,
            String(statsComputed.weeklyDays[i] || 0),
            this.formatSecondsToHoursText(statsComputed.weeklyWeekdayWork[i] || 0),
        ]);
        weeklyBody.push([
            'Monthly Total Hrs.',
            '',
            this.formatSecondsToHoursText(statsComputed.sumWeekdayWork || 0),
        ]);
        autoTable(doc, {
            startY: (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 12 : 160,
            head: [weeklyHead],
            body: weeklyBody,
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'left' },
            columnStyles: { 1: { halign: 'right' }, 2: { halign: 'right' } },
            theme: 'grid',
        });

        const fileName = `Attendance_${userInfo.name || 'user'}_${y}-${m}.pdf`;
        doc.save(fileName);
    };

    handlePageSizeChangeMonthly = (pageSize) => {
        this.setState({ pageSizeMonthly: pageSize });
    };

    handlePageSizeChangeDaily = (pageSize) => {
        this.setState({ pageSizeDaily: pageSize });
    };

    handleChangeDaily = (e) => {
        const searchQueryDaily = e.target.value.toLowerCase();
        const suggestionsDaily = this.state.dailyLogData.filter((item) => {
            return (
                item.date.includes(searchQueryDaily) ||
                item.firstname.toLowerCase().includes(searchQueryDaily) ||
                (item.user_name && item.user_name.toLowerCase().includes(searchQueryDaily)) ||
                (item.type && item.type.toLowerCase().includes(searchQueryDaily))
            );
        });
        this.setState({ searchQueryDaily, suggestionsDaily }, this.handleSearchDaily);
    };

    handleChangeMonthly = (e) => {
        const searchQueryMonthly = e.target.value.toLowerCase();
        const suggestionsMonthly = this.state.Attendance.filter((item) => {
            return (
                item.date.includes(searchQueryMonthly) ||
                item.firstname.toLowerCase().includes(searchQueryMonthly) ||
                (item.user_name && item.user_name.toLowerCase().includes(searchQueryMonthly)) ||
                (item.status && item.status.toLowerCase().includes(searchQueryMonthly))
            );
        });
        this.setState({ searchQueryMonthly, suggestionsMonthly }, this.handleSearchMonthly);
    };

    handleSearchMonthly = () => {
        const { Attendance, searchQueryMonthly, selectedUser, selectedDate } = this.state;
        const [selectedYear, selectedMonth] = selectedDate.split('-');

        const filterEvents = Attendance.filter((item) => {
            const [, itemMonth, itemYear] = item.date.split('-');
            const matchesDateOrName =
                item.date.includes(searchQueryMonthly) ||
                item.firstname.toLowerCase().includes(searchQueryMonthly.toLowerCase()) ||
                (item.user_name && item.user_name.toLowerCase().includes(searchQueryMonthly.toLowerCase())) ||
                (item.status && item.status.toLowerCase().includes(searchQueryMonthly.toLowerCase()));
            const matchesUser = selectedUser ? item.firstname === selectedUser : true;
            const matchesMonthYear = itemYear === selectedYear && itemMonth === selectedMonth;
            return matchesDateOrName && matchesUser && matchesMonthYear;
        });
        this.setState({ filterEvents });
    };

    // Method to filter by selected user only (without search query)
    filterBySelectedUser = () => {
        const { Attendance, selectedUser, selectedDate } = this.state;
        const [selectedYear, selectedMonth] = selectedDate.split('-');

        const filterEvents = Attendance.filter((item) => {
            const [, itemMonth, itemYear] = item.date.split('-');
            const matchesUser = selectedUser ? item.firstname === selectedUser : true;
            const matchesMonthYear = itemYear === selectedYear && itemMonth === selectedMonth;
            return matchesUser && matchesMonthYear;
        });
        this.setState({ filterEvents });
    };

    handleSearchDaily = () => {
        const filterEventsDaily = this.state.dailyLogData.filter((item) => {
            return (
                item.date.includes(this.state.searchQueryDaily) ||
                item.firstname.toLowerCase().includes(this.state.searchQueryDaily.toLowerCase()) ||
                (item.user_name && item.user_name.toLowerCase().includes(this.state.searchQueryDaily.toLowerCase())) ||
                (item.type && item.type.toLowerCase().includes(this.state.searchQueryDaily.toLowerCase()))
            );
        });
        this.setState({ filterEventsDaily });
    };

    clearSearchMonthly = () => {
        this.setState({ searchQueryMonthly: "", suggestionsMonthly: [] }, this.handleSearchMonthly);
    };

    clearSearchDaily = () => {
        this.setState({ searchQueryDaily: "", suggestionsDaily: [] }, this.handleSearchDaily);
    };

    handleSuggestionClickMonthly = (value) => {
        const normalizedValue = String(value || "").toLowerCase();
        this.setState({ searchQueryMonthly: normalizedValue, suggestionsMonthly: [] }, this.handleSearchMonthly);
    };

    handleSuggestionClickDaily = (value) => {
        const normalizedValue = String(value || "").toLowerCase();
        this.setState({ searchQueryDaily: normalizedValue, suggestionsDaily: [] }, this.handleSearchDaily);
    };

    getBase64ImageFromUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // excel file download
    downloadAttendanceXLSX = async () => {
        const workbook = new ExcelJS.Workbook();
        const { selectedDate, Attendance, selectedUser, userStatistics } = this.state;
        const [year, month] = selectedDate.split('-');
        const reportType = `Attendance Report for ${month}-${year}`;

        // Get base64 image for logo
        let base64Image;
        try {
            base64Image = await this.getBase64ImageFromUrl(logo);
        } catch (e) {
            console.warn('Logo image could not be loaded for Excel export:', e);
        }

        const columnsFiltered = this.state.columns.filter(col => col.field !== 'firstName');
        const headers = columnsFiltered.map(col => col.headerName);
        const dateIndex = headers.indexOf('Date');
        headers.splice(dateIndex + 1, 0, 'Day');

        // Helper function to add user statistics summary
        const addUserStatisticsSummary = (worksheet, userStats, totalWorkingDays, totalMonthWorkingDays, isAllUsers = false) => {

            // Add logo and header
            const fillColor = 'FFFFFF00';
            for (let row = 1; row <= 2; row++) {
                for (let col = 1; col <= 9; col++) {
                    const cell = worksheet.getCell(row, col);
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor }
                    };
                }
            }

            // Add logo to each worksheet
            if (base64Image) {
                try {
                    const currentImageId = workbook.addImage({
                        base64: base64Image.split(',')[1],
                        extension: 'png',
                    });
                    const columnWidth = worksheet.getColumn(1).width || 10;
                    const imageWidth = 50;
                    const startCol = (columnWidth - imageWidth / 7.5) / 6;
                    worksheet.addImage(currentImageId, {
                        tl: { col: startCol, row: 0 },
                        ext: { width: imageWidth, height: 40 }
                    });
                } catch (e) {
                    console.warn('Logo could not be added to worksheet:', e);
                }
            }

            worksheet.getCell('B1').value = `Cherrypik Software Attendance Report`;
            worksheet.getCell('B2').value = isAllUsers ? `${userStats.firstname} - ${reportType}` : reportType;
            worksheet.getCell('B3').font = { bold: true, size: 14 };

            // Add user statistics summary horizontally
            const statsStartRow = 4;
            worksheet.getCell(`A${statsStartRow}`).value = 'User Statistics Summary';
            worksheet.getCell(`A${statsStartRow}`).font = { bold: true, size: 12 };
            worksheet.getCell(`A${statsStartRow}`).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE6F3FF' }
            };

            // Statistics headers (horizontal)
            const statsHeaders = ['Late', 'Absent/Leave', 'Half Day', 'Present', 'Week Off', 'Holiday', 'Left Early', 'Leave Days', 'Total Working Day', 'Total Month Working Days'];
            const statsCounts = [
                userStats.comes_late_count || 0,
                `${userStats.absent_count || 0}/${userStats.leave_count || 0}`,
                userStats.half_day_count || 0,
                userStats.present_count || 0,
                userStats.week_off_count || 0,
                userStats.holiday_count || 0,
                userStats.left_early_count || 0,
                userStats.leave_days_count || 0,
                totalWorkingDays || 0,
                totalMonthWorkingDays || 0
            ];

            // Add statistics headers row
            const headerRow = worksheet.addRow(statsHeaders);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4CAF50' },
                };
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });

            // Add statistics counts row
            const countsRow = worksheet.addRow(statsCounts);
            countsRow.eachCell((cell) => {
                cell.alignment = { horizontal: 'center' };
                cell.font = { bold: true, size: 11 };
            });

            // Add empty row after statistics
            worksheet.addRow([]);

            return statsStartRow + 4; // Return the row where data should start
        };

        // Helper function to create a worksheet for a specific user
        const createUserWorksheet = (userData, userName, isAllUsers = false) => {
            const sheetName = isAllUsers ? userName.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 31) : 'Attendance';
            const worksheet = workbook.addWorksheet(sheetName);

            // Find user statistics
            const userStats = this.getEffectiveUserStatistics(
                userStatistics.find(stat => stat.firstname === userName) || {
                    ...this.getDefaultUserStatistics(),
                    firstname: userName
                },
                userData,
                userName
            );
            const totalWorkingDays = this.getTotalWorkingDays(userStats, userData, userName);
            const totalMonthWorkingDays = this.getTotalMonthWorkingDays(selectedDate, userStats, userData, userName);

            // Add statistics summary and get the starting row for data
            const dataStartRow = addUserStatisticsSummary(worksheet, userStats, totalWorkingDays, totalMonthWorkingDays, isAllUsers);

            // Add headers
            const headerRow = worksheet.addRow(headers);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF00FF00' },
                };
                cell.font = { bold: true };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });

            // Add data rows
            if (userData.length === 0) {
                worksheet.getCell(`A${dataStartRow + 1}`).value = 'No Data Available';
                worksheet.mergeCells(`A${dataStartRow + 1}:I${dataStartRow + 1}`);
                worksheet.getCell(`A${dataStartRow + 1}`).alignment = { horizontal: 'center' };
            } else {
                userData.forEach(row => {
                    const rowData = columnsFiltered.map(col => row[col.field]);
                    const dateValue = row['date'];
                    let dayValue = '';
                    if (dateValue) {
                        const [day, month, year] = dateValue.split('-');
                        const jsDate = new Date(`${year}-${month}-${day}`);
                        dayValue = jsDate.toLocaleDateString('en-US', { weekday: 'long' });
                    }
                    rowData.splice(dateIndex + 1, 0, dayValue);
                    const addedRow = worksheet.addRow(rowData);

                    const statusColIndex = headers.indexOf('Status') + 1;
                    const statusValue = row['status'];
                    const statusColor = this.state.statusColors && this.state.statusColors[statusValue]
                        ? this.state.statusColors[statusValue].replace('#', '')
                        : '000000';

                    if (statusColIndex > 0) {
                        addedRow.getCell(statusColIndex).font = {
                            color: { argb: `FF${statusColor.toUpperCase()}` },
                            bold: true,
                        };
                    }
                });
            }

            // Set column widths
            worksheet.columns.forEach(column => {
                column.width = 20;
            });

            return worksheet;
        };

        // Check if we need to create multiple sheets (All Users selected)
        if (!selectedUser) {
            // Group attendance data by user
            const userGroups = {};
            Attendance.forEach(row => {
                const userName = row.firstname;
                if (!userGroups[userName]) {
                    userGroups[userName] = [];
                }
                userGroups[userName].push(row);
            });

            // Create a worksheet for each user
            Object.keys(userGroups).forEach(userName => {
                createUserWorksheet(userGroups[userName], userName, true);
            });

            // If no users found, create a default sheet
            if (Object.keys(userGroups).length === 0) {
                createUserWorksheet([], 'No Data');
            }
        } else {
            // Single user selected - create one sheet
            const userData = Attendance.filter(event => event.firstname === selectedUser);
            createUserWorksheet(userData, selectedUser);
        }

        // Generate filename
        const roles = ls.get("roles");
        const userName = ls.get("user").firstName + " " + ls.get("user").lastName;
        let fileName = '';

        if (roles && roles.includes("Super Admin")) {
            if (selectedUser) {
                fileName = `${selectedUser} Attendance ${month}-${year}.xlsx`;
            } else {
                fileName = `All Users Attendance ${month}-${year}.xlsx`;
            }
        } else {
            fileName = `${userName} Attendance ${month}-${year}.xlsx`;
        }

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
    };


    handleUserChange(event) {
        const selectedUser = event.target.value;
        this.setState({ selectedUser }, () => {
            if (selectedUser) {
                this.filterBySelectedUser();
            } else {
                // If no user selected, show all data
                this.setState({ filterEvents: this.state.Attendance });
            }
        });
    }


    render() {
        const { columns, Attendance, selectedDate, showMonthlyLog, selectedDatejh, dailyLogColumns, pageSizeMonthly, pageSizeDaily, searchQueryMonthly, searchQueryDaily, suggestionsMonthly, suggestionsDaily, selectedUser, uniqueUsers, monthlyLoading, dailyLoading } = this.state;
        const roleList = this.getRoleList();
        const canSelectUser = roleList.includes("Super Admin") || roleList.includes("Admin");
        const filterEvents = this.state.filterEvents || this.state.Attendance;
        const filterEventsDaily = searchQueryDaily
            ? (Array.isArray(this.state.filterEventsDaily) ? this.state.filterEventsDaily : [])
            : this.state.dailyLogData;
        const hasDailyLogRows = Array.isArray(filterEventsDaily) && filterEventsDaily.length > 0;
        const hasMonthlyRows = Array.isArray(filterEvents) && filterEvents.length > 0;
        const dailyLogEmptyMessage = searchQueryDaily
            ? "No daily log records match your search for the selected date."
            : "No timer in/out records found for the selected date.";
        const monthlyEmptyMessage = searchQueryMonthly
            ? "No monthly attendance records match your search."
            : "No attendance records found for the selected month.";
        
        const query = this.state.userSearchQuery.toLowerCase();
        const filteredUniqueUsers = uniqueUsers.filter(u => 
            u.name.toLowerCase().includes(query)
        );

        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark' || document.body.classList.contains('dark-theme');
        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div>
                            <div className="holiday-breadcrumb-card" style={{ width: "98%", margin: "0 auto 20px auto" }}>
                                <Breadcrumb
                                    {...this.props}
                                    primaryPageName="Attendance"
                                    primaryPageLink="/attendance"
                                    isSecondaryPage={false}
                                    secondaryPageName="" />
                            </div>
                            <div
                                style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginInlineStart: "35px"
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    className={`common-toggle-button ${!showMonthlyLog ? 'is-active' : ''}`}
                                    style={{
                                        marginRight: '10px',
                                        textTransform: 'none'
                                    }}
                                    onClick={this.handleShowDailyLog}
                                >
                                    Daily Log
                                </Button>
                                <Button
                                    variant="outlined"
                                    className={`common-toggle-button ${showMonthlyLog ? 'is-active' : ''}`}
                                    style={{
                                        textTransform: 'none'
                                    }}
                                    onClick={this.handleShowMonthlyLog}
                                >
                                    Monthly Log
                                </Button>
                            </div>
                            {/* monthly Attendance table */}
                            {showMonthlyLog ? (
                                <Card
                                    className="attendance-table-shell holiday-table-shell"
                                    style={{
                                        padding: "20px 20px 0 20px",
                                        minHeight: "auto",       // Card height adjusts based on content
                                        height: "auto",
                                        overflow: "visible",
                                        marginBottom: "30px",     // Adds bottom spacing
                                        width: "98%",
                                        margin: "0 auto 30px auto"
                                    }}
                                >
                                    <div style={{ marginBottom: "0px" }}>
                                        {/* Filters Section */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                marginBottom: '20px',
                                                marginTop: '5%'
                                            }}
                                        >
                                            {/* Select Month */}
                                            <TextField
                                                className="attendance-header-field"
                                                id="month"
                                                label="Select month"
                                                variant="outlined"
                                                type="month"
                                                value={selectedDate}
                                                onChange={this.handleDateChange}
                                                inputProps={{ max: this.getCurrentMonth() }}
                                                InputLabelProps={{ 
                                                    shrink: true,
                                                    style: {
                                                        color: '#036dda',
                                                        fontWeight: 700,
                                                        backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
                                                        padding: '0 4px'
                                                    }
                                                }}
                                                InputProps={{
                                                    style: {
                                                        color: isDarkMode ? '#ffffff' : '#036dda',
                                                        fontWeight: 600
                                                    }
                                                }}
                                                style={{ minWidth: 200 }}
                                            />

                                            {/* Select User (admins only) - Popover Version */}
                                            {canSelectUser && (
                                                <div className="attendance-filter-container">
                                                    <TextField
                                                        className="attendance-header-field"
                                                        label="Select User"
                                                        variant="outlined"
                                                        value={selectedUser || "All Users"}
                                                        onClick={this.handleOpenUserPopover}
                                                        style={{ width: 200 }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                            style: {
                                                                color: '#036dda',
                                                                fontWeight: 700,
                                                                backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
                                                                padding: '0 4px'
                                                            }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                            style: {
                                                                cursor: 'pointer',
                                                                color: isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                                                                fontWeight: 600
                                                            },
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <ExpandMoreIcon style={{ color: isDarkMode ? '#fff' : '#666', cursor: 'pointer' }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />

                                                    <Popover
                                                        open={Boolean(this.state.userPopoverAnchor)}
                                                        anchorEl={this.state.userPopoverAnchor}
                                                        onClose={this.handleCloseUserPopover}
                                                        disableScrollLock
                                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                        PaperProps={{
                                                            className: 'attendance-user-popover-paper',
                                                            style: {
                                                                width: 300,
                                                                marginTop: 5,
                                                                borderRadius: 8,
                                                                boxShadow: isDarkMode ? '0 4px 20px rgba(255,255,255,0.1)' : '0 4px 20px rgba(0,0,0,0.1)',
                                                                backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
                                                                color: isDarkMode ? '#ffffff' : 'inherit'
                                                            }
                                                        }}
                                                    >
                                                        <Box p={1.5} className="attendance-user-popover-header">
                                                            <Typography
                                                                variant="subtitle2"
                                                                className="attendance-user-popover-title"
                                                                style={{
                                                                    fontWeight: 700,
                                                                    marginBottom: 8,
                                                                    color: isDarkMode ? '#ffffff' : '#ffffff'
                                                                }}
                                                            >
                                                                Select User
                                                            </Typography>
                                                            <TextField
                                                                className="common-user-search-field"
                                                                fullWidth
                                                                size="small"
                                                                placeholder="Search users..."
                                                                variant="outlined"
                                                                value={this.state.userSearchQuery}
                                                                onChange={(e) => this.setState({ userSearchQuery: e.target.value })}
                                                                InputProps={{
                                                                    style: {
                                                                        color: isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)'
                                                                    },
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <SearchIcon fontSize="small" style={{ color: isDarkMode ? '#ffffff' : 'inherit' }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        </Box>
                                                        <Divider />
                                                        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                                            <MenuItem 
                                                                className="attendance-user-option"
                                                                onClick={() => this.handleSelectUser("")}
                                                                style={{ padding: '8px 16px' }}
                                                            >
                                                                <ListItemText primary="All Users" />
                                                                {!selectedUser && <CheckIcon style={{ color: '#16a34a', fontSize: '1.2rem' }} />}
                                                            </MenuItem>
                                                            {filteredUniqueUsers.map((user, index) => (
                                                                <MenuItem 
                                                                    className="attendance-user-option"
                                                                    key={index} 
                                                                    onClick={() => this.handleSelectUser(user.name)}
                                                                    style={{ padding: '8px 16px' }}
                                                                >
                                                                    <Box display="flex" alignItems="center" width="100%">
                                                                        <Avatar 
                                                                            src={user.photo || ""} 
                                                                            style={{ width: 32, height: 32, marginRight: 12, fontSize: '0.9rem' }}
                                                                        >
                                                                            {user.initials}
                                                                        </Avatar>
                                                                        <ListItemText primary={user.name} />
                                                                        {selectedUser === user.name && <CheckIcon style={{ color: '#16a34a', fontSize: '1.2rem' }} />}
                                                                    </Box>
                                                                </MenuItem>
                                                            ))}
                                                        </div>
                                                    </Popover>
                                                </div>
                                            )}
                                        </div>

                                        {/* Filter and Search */}
                                        <div
                                            style={{
                                                position: "absolute",
                                                right: "67px",
                                                marginTop: "-60px",
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}
                                        >
                                            <IconButton
                                                onClick={this.openUserStatsModal}
                                                title="Filter Total Hours"
                                                className="common-action-button"
                                                style={{
                                                    borderRadius: 6,
                                                    width: 48,
                                                    height: 40
                                                }}
                                            >
                                                <FilterListIcon htmlColor="#ffffff" />
                                            </IconButton>



                                            <TextField
                                                label="Search"
                                                value={searchQueryMonthly}
                                                onChange={this.handleChangeMonthly}
                                                variant="outlined"
                                                autoComplete="off"
                                                InputLabelProps={{
                                                    shrink: searchQueryMonthly !== "",
                                                    style: {
                                                        color: isDarkMode ? '#ffffff' : '#000000',
                                                        fontWeight: 700,
                                                        transform: searchQueryMonthly !== ""
                                                            ? 'translate(14px, -6px) scale(0.75)'
                                                            : 'translate(14px, 11px) scale(1)',
                                                        transition: 'transform 0.2s ease-in-out'
                                                    }
                                                }}
                                                InputProps={{
                                                    style: {
                                                        backgroundColor: isDarkMode ? '#2a2a2a' : 'lightgray',
                                                        borderRadius: '25px',
                                                        height: "40px",
                                                        color: isDarkMode ? '#ffffff' : '#000000'
                                                    },
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {searchQueryMonthly && (
                                                                <ClearIcon
                                                                    onClick={this.clearSearchMonthly}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            )}
                                                            <SearchIcon
                                                                onClick={this.handleSearchMonthly}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>

                                        {/* Suggestions */}
                                        {searchQueryMonthly && suggestionsMonthly.length > 0 && (
                                            <Paper
                                                style={{
                                                    position: 'absolute',
                                                    right: '130px',
                                                    marginTop: '-20px',
                                                    zIndex: 1,
                                                    width: "213px",
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    border: isDarkMode ? '1px solid #444' : '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    boxShadow: isDarkMode ? '0 2px 10px rgba(255, 255, 255, 0.1)' : '0 2px 10px rgba(0, 0, 0, 0.1)',
                                                    backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
                                                    color: isDarkMode ? '#ffffff' : 'inherit'
                                                }}
                                            >
                                                {[...new Set(
                                                    suggestionsMonthly
                                                        .flatMap(suggestion => [suggestion.firstname, suggestion.user_name, suggestion.status])
                                                        .filter(Boolean)
                                                        .filter(value => value.toLowerCase().includes(searchQueryMonthly))
                                                )].map((value, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        onClick={() => this.handleSuggestionClickMonthly(value)}
                                                    >
                                                        {value}
                                                    </MenuItem>
                                                ))}
                                            </Paper>
                                        )}

                                        {/* Data Grid */}
                                        <div className="dashboard-attendance-table" style={{ width: '100%', marginTop: "40px" }}>
                                            <DataGrid
                                                className="dashboard-attendance-grid"
                                                columns={columns}
                                                rows={filterEvents}
                                                getRowId={(row) => row.id || row.user_id + '_' + row.date || Math.random()}
                                                page={this.state.pageMonthly}
                                                pageSize={pageSizeMonthly}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                onPageChange={(newPage) => this.setState({ pageMonthly: newPage })}
                                                onPageSizeChange={(newPageSize) => this.handlePageSizeChangeMonthly(newPageSize)}
                                                disableRowSelectionOnClick
                                                hideFooter
                                                headerHeight={40}
                                                rowHeight={40}
                                                autoHeight
                                                getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? "zebra-table-row" : ""}
                                                components={{
                                                    NoRowsOverlay: () => (
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            height: "100%",
                                                            color: isDarkMode ? '#ffffff' : 'inherit',
                                                            backgroundColor: isDarkMode ? '#1e1e1e' : 'inherit'
                                                        }}>
                                                            {monthlyLoading ? (
                                                                <CircularProgress
                                                                    size={26}
                                                                    thickness={3.6}
                                                                    color="primary"
                                                                    className="dashboard-attendance-spinner"
                                                                />
                                                            ) : (
                                                                monthlyEmptyMessage
                                                            )}
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div 
                                            className="shared-table-bottom-bar"
                                            style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'center', 
                                                marginTop: "10px", 
                                                visibility: hasMonthlyRows ? 'visible' : 'hidden' 
                                            }}
                                        >
                                            <div style={{ paddingLeft: '4px' }}>
                                                <ExportButton
                                                    label="Download Attendance Xlsx"
                                                    onClick={this.downloadAttendanceXLSX}
                                                />
                                            </div>
                                            <TablePagination
                                                component="div"
                                                count={filterEvents.length}
                                                page={this.state.pageMonthly}
                                                onPageChange={this.handlePageChangeMonthly}
                                                rowsPerPage={pageSizeMonthly}
                                                SelectProps={commonPaginationSelectProps}
                                                onRowsPerPageChange={(e) => {
                                                    this.handlePageSizeChangeMonthly(parseInt(e.target.value, 10));
                                                    this.setState({ pageMonthly: 0 });
                                                }}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                className={`${COMMON_PAGINATION_CLASS} shared-table-bottom-pagination`}
                                                style={getCommonPaginationStyle(isDarkMode)}
                                                ActionsComponent={CommonTablePaginationActions}
                                            />
                                        </div>
                                    </div>
                                </Card>

                            ) : (

                                // dayly Attendance table 
                                <Card
                                    className="attendance-table-shell holiday-table-shell"
                                    style={{
                                        padding: "20px 20px 0 20px",
                                        minHeight: "auto",
                                        height: "auto",
                                        overflow: "visible",
                                        marginBottom: "30px",
                                        width: "98%",
                                        margin: "0 auto 30px auto"
                                    }}
                                >
                                    <div style={{ paddingBottom: "0px" }}>
                                        <div style={{ marginBottom: '20px', textAlign: 'right' }}>
                                            <TextField
                                                id="date"
                                                className="attendance-header-field"
                                                label="Select date"
                                                variant="outlined"
                                                type="date"
                                                value={selectedDatejh}
                                                onChange={this.handledayChange}
                                                inputProps={{ max: this.getCurrentDate() }}
                                            InputLabelProps={{ 
                                                shrink: true,
                                                style: {
                                                    color: '#036dda',
                                                    fontWeight: 700,
                                                    backgroundColor: 'transparent',
                                                    padding: 0
                                                }
                                            }}
                                                style={{ marginRight: '10px' }}
                                            />
                                        </div>
                                        {!hasDailyLogRows && !dailyLoading && (
                                            <div
                                                style={{
                                                    marginTop: '8px',
                                                    marginBottom: '16px',
                                                    padding: '14px 18px',
                                                    border: isDarkMode ? '1px dashed #4b5563' : '1px dashed #cbd5e1',
                                                    borderRadius: '12px',
                                                    backgroundColor: isDarkMode ? '#161b22' : '#f8fbff',
                                                    color: isDarkMode ? '#ffffff' : '#036dda',
                                                    textAlign: 'center',
                                                    fontSize: '15px',
                                                    fontWeight: 600
                                                }}
                                            >
                                                {dailyLogEmptyMessage}
                                            </div>
                                        )}
                                        {hasDailyLogRows && (
                                            <div className='graphresponsive'>
                                                <canvas
                                                    ref={this.chartRef}
                                                    style={{
                                                        height: '400px',
                                                        width: '100%'
                                                    }}
                                                />
                                            </div>
                                        )}
                                        {hasDailyLogRows && (
                                            <React.Fragment>
                                                <TextField
                                                    label="Search"
                                                    value={searchQueryDaily}
                                                    onChange={this.handleChangeDaily}
                                                    autoComplete="off"
                                                    style={{
                                                        position: "absolute",
                                                        right: "67px",
                                                        marginTop: "15px",
                                                        backgroundColor: 'transparent'
                                                    }}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: searchQueryDaily !== "",
                                                        style: {
                                                            color: isDarkMode ? '#ffffff' : '#000000',
                                                            fontWeight: 700,
                                                            transform: searchQueryDaily !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                                            transition: 'transform 0.2s ease-in-out'
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            backgroundColor: isDarkMode ? '#2a2a2a' : 'lightgray',
                                                            borderRadius: '25px',
                                                            height: "40px",
                                                            overflow: 'hidden',
                                                            color: isDarkMode ? '#ffffff' : '#000000'
                                                        },
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {searchQueryDaily && (
                                                                    <ClearIcon onClick={this.clearSearchDaily} style={{ cursor: 'pointer' }} />
                                                                )}
                                                                <SearchIcon onClick={this.handleSearchDaily} style={{ cursor: 'pointer' }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                {searchQueryDaily && suggestionsDaily.length > 0 && (
                                                    <Paper style={{
                                                        position: 'absolute', right: '130px', marginTop: '62px', zIndex: 1, width: "209px", maxHeight: '200px', overflowY: 'auto',
                                                        border: isDarkMode ? '1px solid #444' : '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        boxShadow: isDarkMode ? '0 2px 10px rgba(255, 255, 255, 0.1)' : '0 2px 10px rgba(0, 0, 0, 0.1)',
                                                        backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
                                                        color: isDarkMode ? '#ffffff' : 'inherit'
                                                    }}>
                                                        {[...new Set(
                                                            suggestionsDaily
                                                                .flatMap(suggestion => [suggestion.firstname, suggestion.user_name, suggestion.type])
                                                                .filter(Boolean)
                                                                .filter(value => value.toLowerCase().includes(searchQueryDaily))
                                                        )].map((value, index) => (
                                                            <MenuItem key={index} onClick={() => this.handleSuggestionClickDaily(value)}>
                                                                {value}
                                                            </MenuItem>
                                                        ))}
                                                    </Paper>
                                                )}
                                            </React.Fragment>
                                        )}
                                        <div className="dashboard-attendance-table" style={{ width: '100%', marginTop: "77px", marginBottom: "25px" }}>
                                            <DataGrid
                                                className="dashboard-attendance-grid"
                                                rows={filterEventsDaily}
                                                columns={dailyLogColumns}
                                                getRowId={(row) => row.id || row.user_id + '_' + row.date + '_' + row.time + '_' + Math.random()}
                                                page={this.state.pageDaily}
                                                pageSize={pageSizeDaily}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                onPageChange={(newPage) => this.setState({ pageDaily: newPage })}
                                                onPageSizeChange={(newPageSize) => this.handlePageSizeChangeDaily(newPageSize)}
                                                disableRowSelectionOnClick
                                                hideFooter
                                                headerHeight={40}
                                                rowHeight={40}
                                                autoHeight={true}
                                                getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? "zebra-table-row" : ""}
                                                components={{
                                                    NoRowsOverlay: () => (
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            height: "100%",
                                                            color: isDarkMode ? '#ffffff' : 'inherit',
                                                            backgroundColor: isDarkMode ? '#1e1e1e' : 'inherit'
                                                        }}>
                                                            {dailyLoading ? (
                                                                <CircularProgress
                                                                    size={26}
                                                                    thickness={3.6}
                                                                    color="primary"
                                                                    className="dashboard-attendance-spinner"
                                                                />
                                                            ) : (
                                                                dailyLogEmptyMessage
                                                            )}
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        {hasDailyLogRows && (
                                            <div 
                                                className="shared-table-bottom-bar pagination-only"
                                                style={{ 
                                                    display: 'flex', 
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'center', 
                                                    marginTop: "10px" 
                                                }}
                                            >
                                                <TablePagination
                                                    component="div"
                                                    count={filterEventsDaily.length}
                                                    page={this.state.pageDaily}
                                                    onPageChange={this.handlePageChangeDaily}
                                                    rowsPerPage={pageSizeDaily}
                                                    SelectProps={commonPaginationSelectProps}
                                                    onRowsPerPageChange={(e) => {
                                                        this.handlePageSizeChangeDaily(parseInt(e.target.value, 10));
                                                        this.setState({ pageDaily: 0 });
                                                    }}
                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                    className={`${COMMON_PAGINATION_CLASS} shared-table-bottom-pagination`}
                                                    style={getCommonPaginationStyle(isDarkMode)}
                                                    ActionsComponent={CommonTablePaginationActions}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            )}
                            <Dialog 
                                open={this.state.isUserStatsOpen} 
                                onClose={this.closeUserStatsModal} 
                                fullWidth 
                                maxWidth="sm" 
                                disableScrollLock
                                PaperProps={{ className: 'attendance-summary-dialog-paper' }}
                            >
                                <DialogTitle className="common-section-header attendance-summary-dialog-title">
                                    <Typography variant="h6" className="attendance-summary-dialog-title-text">User Filter & Summary</Typography>
                                </DialogTitle>
                                <DialogContent className="attendance-summary-dialog-content">
                                    <div style={{ display: 'flex', gap: 16, alignItems: 'center', justifyContent: 'center', marginBottom: 20, flexWrap: 'wrap' }}>

                                                <TextField
                                                    className="attendance-header-field"
                                                    id="modal-month"
                                                    label="Select month"
                                                    variant="outlined"
                                                    type="month"
                                                    value={this.state.modalSelectedMonthYear}
                                                    onChange={this.handleModalMonthChange}
                                                    inputProps={{ max: this.getCurrentMonth() }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        style: {
                                                            color: '#036dda',
                                                            fontWeight: 700,
                                                            backgroundColor: isDarkMode ? '#1e1e2e' : '#ffffff',
                                                            padding: '0 4px'
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            color: isDarkMode ? '#ffffff' : '#036dda',
                                                            fontWeight: 600
                                                        }
                                                    }}
                                                    style={{ width: 210 }}
                                                />
                                        {(ls.get("roles") && ls.get("roles").includes("Super Admin")) ? (
                                            <div className="attendance-filter-container" style={{ width: 210 }}>
                                                <TextField
                                                    className="attendance-header-field"
                                                    label="Select User"
                                                    variant="outlined"
                                                    value={this.state.modalSelectedUser || "Select User"}
                                                    onClick={this.handleOpenModalUserPopover}
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        style: {
                                                            color: '#036dda',
                                                            fontWeight: 700,
                                                            backgroundColor: isDarkMode ? '#1e1e2e' : '#ffffff',
                                                            padding: '0 4px'
                                                        }
                                                    }}
                                                    InputProps={{
                                                        readOnly: true,
                                                        style: {
                                                            cursor: 'pointer',
                                                            color: isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                                                            fontWeight: 600
                                                        },
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <ExpandMoreIcon style={{ color: isDarkMode ? '#fff' : '#666', cursor: 'pointer' }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />

                                                <Popover
                                                    open={Boolean(this.state.modalUserPopoverAnchor)}
                                                    anchorEl={this.state.modalUserPopoverAnchor}
                                                    onClose={this.handleCloseModalUserPopover}
                                                    disableScrollLock
                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                    PaperProps={{
                                                        className: 'attendance-user-popover-paper',
                                                        style: {
                                                            width: 300,
                                                            marginTop: 5,
                                                            borderRadius: 8,
                                                            boxShadow: isDarkMode ? '0 4px 20px rgba(255,255,255,0.1)' : '0 4px 20px rgba(0,0,0,0.1)',
                                                            backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
                                                            color: isDarkMode ? '#ffffff' : 'inherit'
                                                        }
                                                    }}
                                                >
                                                    <Box p={1.5} className="attendance-user-popover-header">
                                                        <Typography
                                                            variant="subtitle2"
                                                            className="attendance-user-popover-title"
                                                            style={{
                                                                fontWeight: 700,
                                                                marginBottom: 8,
                                                                color: isDarkMode ? '#ffffff' : '#ffffff'
                                                            }}
                                                        >
                                                            Select User
                                                        </Typography>
                                                        <TextField
                                                            className="common-user-search-field"
                                                            fullWidth
                                                            size="small"
                                                            placeholder="Search users..."
                                                            variant="outlined"
                                                            value={this.state.userSearchQuery}
                                                            onChange={(e) => this.setState({ userSearchQuery: e.target.value })}
                                                            InputProps={{
                                                                style: {
                                                                    color: isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)'
                                                                },
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <SearchIcon fontSize="small" style={{ color: isDarkMode ? '#ffffff' : 'inherit' }} />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Box>
                                                    <Divider />
                                                    <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                                        <MenuItem 
                                                            className="attendance-user-option"
                                                            onClick={() => this.handleSelectModalUser("")}
                                                            style={{ padding: '8px 16px' }}
                                                        >
                                                            <ListItemText primary="Choose User" />
                                                            {!this.state.modalSelectedUser && <CheckIcon style={{ color: '#16a34a', fontSize: '1.2rem' }} />}
                                                        </MenuItem>
                                                        {filteredUniqueUsers.map((user, index) => (
                                                            <MenuItem 
                                                                className="attendance-user-option"
                                                                key={index} 
                                                                onClick={() => this.handleSelectModalUser(user.name)}
                                                                style={{ padding: '8px 16px' }}
                                                            >
                                                                <Box display="flex" alignItems="center" width="100%">
                                                                    <Avatar 
                                                                        src={user.photo || ""} 
                                                                        style={{ width: 32, height: 32, marginRight: 12, fontSize: '0.9rem' }}
                                                                    >
                                                                        {user.initials}
                                                                    </Avatar>
                                                                    <ListItemText primary={user.name} />
                                                                    {this.state.modalSelectedUser === user.name && <CheckIcon style={{ color: '#16a34a', fontSize: '1.2rem' }} />}
                                                                </Box>
                                                            </MenuItem>
                                                        ))}
                                                    </div>
                                                </Popover>
                                            </div>
                                        ) : (
                                            <TextField
                                                label="User"
                                                value={this.state.modalSelectedUser}
                                                variant="outlined"
                                                disabled
                                                style={{ width: 160 }}
                                            />
                                        )}
                                    </div>
                                    {this.state.modalSelectedUser ? (() => {
                                        const stats = this.computeUserMonthlyAndWeeklyTotals();
                                        const userInfo = this.getModalUserInfo();
                                        const selMY = this.state.modalSelectedMonthYear || this.state.selectedDate;
                                        let monthShort = '';
                                        if (selMY && selMY.includes('-')) {
                                            const [y, m] = selMY.split('-');
                                            const dt = new Date(`${y}-${m}-01T00:00:00`);
                                            monthShort = dt.toLocaleString('en-US', { month: 'short' });
                                        }
                                        return (
                                            <div>
                                                <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                                                    <TableContainer component={Paper} style={{ borderRadius: 8, flex: 1, minWidth: 260 }}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan={2} style={{ fontWeight: 700, backgroundColor: '#036dda', color: '#ffffff' }}>User Details</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow className="zebra-table-row">
                                                                    <TableCell>User</TableCell>
                                                                    <TableCell>{userInfo.name || '-'}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Employee ID</TableCell>
                                                                    <TableCell>{userInfo.employeeId || '-'}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TableContainer component={Paper} style={{ borderRadius: 8, flex: 1, minWidth: 260 }}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan={2} style={{ fontWeight: 700, backgroundColor: '#036dda', color: '#ffffff' }}>Monthly Totals</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow className="zebra-table-row">
                                                                    <TableCell>Work</TableCell>
                                                                    <TableCell style={{ textAlign: 'left', fontWeight: 600 }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            {this.formatSecondsToHoursText(stats.monthly.work)}
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Present Days</TableCell>
                                                                    <TableCell style={{ textAlign: 'left' }}>{stats.monthly.presentDays}</TableCell>
                                                                </TableRow>
                                                                {(() => {
                                                                    const userStats = this.state.modalUserStatistics.find(stat => stat.firstname === this.state.modalSelectedUser);
                                                                    const leaveDays = userStats && userStats.leave_days_count ? userStats.leave_days_count : 0;
                                                                    const totalWorkingDays = this.getTotalWorkingDays(userStats, this.state.modalAttendance, this.state.modalSelectedUser);
                                                                    const totalMonthWorkingDays = this.getTotalMonthWorkingDays(this.state.modalSelectedMonthYear || this.state.selectedDate, userStats, this.state.modalAttendance, this.state.modalSelectedUser);
                                                                    return leaveDays > 0 ? (
                                                                        <>
                                                                            <TableRow className="zebra-table-row">
                                                                                <TableCell>Leave Days</TableCell>
                                                                                <TableCell style={{ textAlign: 'left' }}>{leaveDays}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell>Total Working Day</TableCell>
                                                                                <TableCell style={{ textAlign: 'left' }}>{totalWorkingDays}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow className="zebra-table-row">
                                                                                <TableCell>Total Month Working Days</TableCell>
                                                                                <TableCell style={{ textAlign: 'left' }}>{totalMonthWorkingDays}</TableCell>
                                                                            </TableRow>
                                                                        </>
                                                                    ) : null;
                                                                })()}
                                                                {(() => {
                                                                    const userStats = this.state.modalUserStatistics.find(stat => stat.firstname === this.state.modalSelectedUser);
                                                                    const leaveDays = userStats && userStats.leave_days_count ? userStats.leave_days_count : 0;
                                                                    const totalWorkingDays = this.getTotalWorkingDays(userStats, this.state.modalAttendance, this.state.modalSelectedUser);
                                                                    const totalMonthWorkingDays = this.getTotalMonthWorkingDays(this.state.modalSelectedMonthYear || this.state.selectedDate, userStats, this.state.modalAttendance, this.state.modalSelectedUser);
                                                                    return leaveDays > 0 ? null : (
                                                                        <>
                                                                            <TableRow className="zebra-table-row">
                                                                                <TableCell>Total Working Day</TableCell>
                                                                                <TableCell style={{ textAlign: 'left' }}>{totalWorkingDays}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell>Total Month Working Days</TableCell>
                                                                                <TableCell style={{ textAlign: 'left' }}>{totalMonthWorkingDays}</TableCell>
                                                                            </TableRow>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                                <Divider style={{ margin: '16px 0' }} />

                                                <TableContainer component={Paper} style={{ marginTop: 12, borderRadius: 8 }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ backgroundColor: '#036dda' }}>
                                                                <TableCell style={{ fontWeight: 700, color: '#ffffff' }}>Week</TableCell>
                                                                <TableCell style={{ fontWeight: 700, textAlign: 'center', color: '#ffffff' }}>Present Days</TableCell>
                                                                <TableCell style={{ fontWeight: 700, textAlign: 'center', color: '#ffffff' }}>Total Hrs.</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {stats.weeklyDateRanges.map((dateRange, week) => (
                                                                <TableRow key={week} className={week % 2 === 0 ? "zebra-table-row" : ""}>
                                                                    <TableCell>
                                                                        <div>
                                                                            <div style={{ fontWeight: 600 }}>Week {week + 1}</div>
                                                                            <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                                                                                {dateRange || ''}
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'center' }}>{stats.weeklyDays[week]}</TableCell>
                                                                    <TableCell style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            {this.formatSecondsToHoursText(stats.weeklyWeekdayWork[week])}
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow className={stats.weeklyDateRanges.length % 2 === 0 ? "zebra-table-row" : ""}>
                                                                <TableCell style={{ fontWeight: 700 }}>Monthly Total Hrs.{monthShort ? ` (${monthShort})` : ''}</TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell style={{ fontWeight: 700, textAlign: 'center' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        {this.formatSecondsToHoursText(stats.sumWeekdayWork)}
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        );
                                    })() : (
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                padding: '30px 0',
                                                color: isDarkMode ? '#e2e8f0' : '#4a5568',
                                                fontSize: '15px',
                                                fontWeight: 500
                                            }}
                                        >
                                            Please select a user to view totals.
                                        </div>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <IconButton
                                        className="common-action-icon"
                                        aria-label="download"
                                        title="Download PDF"
                                        onClick={this.downloadModalPdf}
                                        disabled={!this.state.modalSelectedUser}
                                        style={{
                                            color: this.state.modalSelectedUser ? 'var(--hrms-primary-blue-end, #036dda)' : '#9aa9b5',
                                            opacity: this.state.modalSelectedUser ? 1 : 0.5,
                                            cursor: this.state.modalSelectedUser ? 'pointer' : 'not-allowed'
                                        }}
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                    <Button
                                        onClick={this.closeUserStatsModal}
                                        color="primary"
                                        variant="contained"
                                        className="common-action-button"
                                        style={{ textTransform: 'none' }}
                                    >
                                        Close
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    }
                />
                <Footer {...this.props} />
            </div>
        );
    }
}

export default Attendance;




